(function () {
  "use strict";

  var CFG = window.NL_YEAR_OFFER || {};
  var NAMES = ["Jessica", "Amanda", "Michelle", "Rachel", "Lauren", "Nicole", "Ashley", "Brittany"];
  var CITIES = ["Columbus OH", "Phoenix AZ", "Nashville TN", "Denver CO", "Tampa FL", "Austin TX"];
  var kachingSellingPlanId = null;

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function selectedPlan() {
    var el = document.querySelector('.nl-yo-plan input[name="nl-billing"]:checked');
    return el ? el.value : "full";
  }

  function track(event, data) {
    if (window.NLTracking && window.NLTracking.track) {
      window.NLTracking.track(event, data || {});
    }
  }

  function addToCart(variantId, sellingPlanId) {
    var item = { id: Number(variantId), quantity: 1 };
    if (sellingPlanId) item.selling_plan = Number(sellingPlanId);
    return fetch("/cart/clear.js", { method: "POST", credentials: "same-origin" })
      .catch(function () {})
      .then(function () {
        return fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [item] }),
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error("add failed");
        return res.json();
      });
  }

  function checkout() {
    var plan = selectedPlan();
    var variantId;
    var sellingPlanId = null;
    var value;
    var contentName;

    if (plan === "monthone") {
      variantId = CFG.monthOneVariantId;
      value = Number(CFG.monthOnePrice);
      contentName = "Nightlight Month One";
    } else if (plan === "monthly") {
      variantId = CFG.monthlyVariantId;
      sellingPlanId = resolveMonthlySellingPlanId();
      value = Number(CFG.monthlyPrice);
      contentName = "Nightlight 11-Month Membership";
    } else {
      variantId = CFG.payInFullVariantId;
      value = Number(CFG.payInFullPrice);
      contentName = "Nightlight 11-Month Membership";
    }

    if (!variantId) return;

    if (plan === "monthly") {
      var planId = resolveMonthlySellingPlanId();
      if (!planId) {
        console.error("[Nightlight] Monthly checkout blocked: no selling plan ID. Republish Kaching plan or check membership product.");
        window.alert("Subscription isn’t available right now. Please refresh the page or contact help@theparentsworld.com.");
        return;
      }
      syncKachingSellingPlanInputs(planId);
      sellingPlanId = planId;
    }

    document.querySelectorAll(".nl-yo-cta").forEach(function (b) {
      b.disabled = true;
    });

    track("InitiateCheckout", {
      content_name: contentName,
      value: value,
      currency: "USD",
      content_category: plan === "monthone" ? "month_one" : "year_offer",
    });

    addToCart(variantId, sellingPlanId)
      .then(function () {
        if (window.NLCartDrawer && window.NLCartDrawer.fetchCart) {
          return window.NLCartDrawer.fetchCart().then(function (cart) {
            window.NLCartDrawer.renderAndOpen(cart);
          });
        }
        window.location.href = "/checkout";
      })
      .catch(function () {
        window.location.href = "/cart";
      })
      .finally(function () {
        document.querySelectorAll(".nl-yo-cta").forEach(function (b) {
          b.disabled = false;
        });
      });
  }

  function preselectForCro() {
    if (window.location.search.indexOf("purchased=1") !== -1) {
      var full = document.querySelector('.nl-yo-plan input[value="full"]');
      if (full) {
        full.checked = true;
        return;
      }
    }
    var monthlyDefault = document.querySelector('.nl-yo-plan input[value="monthly"]');
    if (monthlyDefault && !document.querySelector('.nl-yo-plan input[name="nl-billing"]:checked')) {
      monthlyDefault.checked = true;
    }
  }

  function bindPlans() {
    preselectForCro();
    document.querySelectorAll(".nl-yo-plan").forEach(function (card) {
      card.addEventListener("click", function (e) {
        if (e.target.tagName === "INPUT") return;
        var input = card.querySelector("input");
        if (input) {
          input.checked = true;
          syncSelected();
        }
      });
    });
    document.querySelectorAll('.nl-yo-plan input[name="nl-billing"]').forEach(function (input) {
      input.addEventListener("change", syncSelected);
    });
    syncSelected();
  }

  function readKachingSellingPlan() {
    var input = document.querySelector('[name="selling_plan"]');
    if (input && input.value) return Number(input.value);
    return kachingSellingPlanId;
  }

  /** Shopify Liquid plan ID is source of truth; Kaching widget can be empty or stale. */
  function resolveMonthlySellingPlanId() {
    var fromTheme = CFG.sellingPlanId ? Number(CFG.sellingPlanId) : null;
    var fromKaching = readKachingSellingPlan();
    if (fromTheme) {
      if (fromKaching && fromKaching !== fromTheme) {
        console.warn("[Nightlight] Kaching selling plan", fromKaching, "ignored; using", fromTheme);
      }
      return fromTheme;
    }
    return fromKaching || null;
  }

  function syncKachingSellingPlanInputs(planId) {
    if (!planId) return;
    document.querySelectorAll('[name="selling_plan"]').forEach(function (el) {
      el.value = String(planId);
    });
  }

  function placeKachingWidget() {
    var slot = document.getElementById("nl-kaching-monthly-slot");
    if (!slot) return;
    var selectors =
      "kaching-subscriptions, kaching-subscriptions-block, kaching-subscriptions-block-v2, .kaching-subscriptions";
    document.querySelectorAll(selectors).forEach(function (el) {
      if (el.closest("header, footer, .cart-drawer, .kaching-subscriptions-sticky-atc, .kaching-subscriptions-sticky-atc-wrapper")) {
        return;
      }
      if (!slot.contains(el)) slot.appendChild(el);
    });
  }

  function initKachingSubscription() {
    document.addEventListener("kaching-subscriptions:selling-plan-change", function (e) {
      var id = e.detail && e.detail.sellingPlanId;
      kachingSellingPlanId = id ? Number(id) : null;
      document.querySelectorAll('[name="selling_plan"]').forEach(function (el) {
        el.value = id ? String(id) : "";
      });
    });
    placeKachingWidget();
    if (typeof MutationObserver !== "undefined") {
      var obs = new MutationObserver(function () {
        placeKachingWidget();
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
    var tries = 0;
    var repoll = setInterval(function () {
      placeKachingWidget();
      tries += 1;
      if (tries >= 12) clearInterval(repoll);
    }, 500);
  }

  function syncSelected() {
    document.querySelectorAll(".nl-yo-plan").forEach(function (card) {
      var on = card.querySelector("input") && card.querySelector("input").checked;
      card.classList.toggle("is-selected", !!on);
    });
    var plan = selectedPlan();
    document.documentElement.classList.toggle("nl-plan-monthly", plan === "monthly");
    if (plan === "monthly" && CFG.sellingPlanId) {
      syncKachingSellingPlanInputs(Number(CFG.sellingPlanId));
    }
    document.documentElement.classList.toggle("nl-plan-monthone", plan === "monthone");
    document.documentElement.classList.toggle("nl-plan-full", plan === "full");
    var sticky = $("#nl-yo-sticky-price");
    var mainBtn = $("#nl-yo-checkout-btn");
    if (sticky) {
      if (plan === "monthone") {
        sticky.textContent = "$" + CFG.monthOnePrice + " · Month One only";
      } else if (plan === "monthly") {
        sticky.textContent = "$" + CFG.monthlyPrice + "/mo · 6 mo min";
      } else {
        sticky.textContent = "$" + CFG.payInFullPrice + " full year · or $" + CFG.monthlyPrice + "/mo";
      }
    }
    document.querySelectorAll(".nl-yo-cta.nl-pdp-cta-primary, #nl-yo-checkout-btn").forEach(function (mainBtn) {
      if (plan === "monthone") {
        mainBtn.textContent = "Download Month One — $" + CFG.monthOnePrice + " →";
      } else if (plan === "monthly") {
        mainBtn.textContent = "Start Subscription — $" + CFG.monthlyPrice + "/mo →";
      } else {
        mainBtn.textContent = "Get Full Year + Bonuses — $" + CFG.payInFullPrice + " →";
      }
    });
    var stickyLabel = document.querySelector(".nl-yo-sticky-btn-label");
    if (stickyLabel) {
      stickyLabel.textContent = plan === "monthone" ? "Buy Month One" : "Secure checkout";
    }
  }

  function tickTimer() {
    var legacy = $("#nl-yo-timer");
    if (!legacy) return;
    var key = "nl_yo_timer_v2";
    var end = Number(sessionStorage.getItem(key) || 0);
    if (!end || end < Date.now()) {
      end = Date.now() + 27 * 60 * 1000 + 18000;
      sessionStorage.setItem(key, String(end));
    }
    function pad2(n) {
      return n < 10 ? "0" + n : String(n);
    }
    function paint() {
      var left = Math.max(0, end - Date.now());
      var h = Math.floor(left / 3600000);
      var m = Math.floor((left % 3600000) / 60000);
      var s = Math.floor((left % 60000) / 1000);
      legacy.textContent = pad2(h) + ":" + pad2(m) + ":" + pad2(s);
    }
    paint();
    setInterval(paint, 1000);
  }

  function tickViewers() {
    var el = $("#nl-yo-viewers");
    if (!el) return;
    function paint() {
      var n = String(41 + Math.floor(Math.random() * 38));
      el.textContent = n;
    }
    paint();
    setInterval(paint, 14000);
  }

  function socialToast() {
    var toast = $("#nl-yo-toast");
    if (!toast) return;
    var avatars = CFG.toastAvatars || [];
    var msgs = [
      "joined the monthly plan",
      "unlocked the full year",
      "downloaded Month One",
      "grabbed the bonus workbooks",
      "chose pay-in-full",
      "started with Month One",
    ];
    var times = ["Just now", "1 min ago", "2 min ago", "4 min ago"];
    var hideTimer = null;

    function esc(s) {
      return String(s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function dismiss() {
      toast.classList.remove("show");
      if (hideTimer) clearTimeout(hideTimer);
    }

    function pop() {
      var name = NAMES[Math.floor(Math.random() * NAMES.length)];
      var city = CITIES[Math.floor(Math.random() * CITIES.length)];
      var msg = msgs[Math.floor(Math.random() * msgs.length)];
      var when = times[Math.floor(Math.random() * times.length)];
      var img =
        avatars.length > 0
          ? avatars[Math.floor(Math.random() * avatars.length)]
          : "";
      var cityShort = city.replace(/\s+[A-Z]{2}$/, "").trim();
      toast.innerHTML =
        '<div class="nl-yo-toast-card">' +
        '<div class="nl-yo-toast-main">' +
        (img
          ? '<span class="nl-yo-toast-ring"><img class="nl-yo-toast-avatar" src="' +
            esc(img) +
            '" alt="" width="32" height="32" loading="lazy"><span class="nl-yo-toast-live" aria-hidden="true"></span></span>'
          : '<span class="nl-yo-toast-ring nl-yo-toast-ring--empty" aria-hidden="true"><span class="nl-yo-toast-live"></span></span>') +
        '<div class="nl-yo-toast-body">' +
        '<div class="nl-yo-toast-text"><strong>' +
        esc(name) +
        "</strong> " +
        esc(msg) +
        "</div>" +
        '<span class="nl-yo-toast-meta">' +
        esc(cityShort) +
        " · " +
        esc(when) +
        "</span>" +
        "</div>" +
        "</div>" +
        '<button type="button" class="nl-yo-toast-close" aria-label="Dismiss"><span aria-hidden="true">×</span></button>' +
        "</div>";
      var closeBtn = toast.querySelector(".nl-yo-toast-close");
      if (closeBtn) closeBtn.addEventListener("click", dismiss);
      toast.classList.add("show");
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(dismiss, 6500);
    }

    setTimeout(pop, 6000);
    setInterval(pop, 20000);
  }

  function postPurchaseNote() {
    if (window.location.search.indexOf("purchased=1") === -1) return;
    var h1 = document.querySelector(".article-container h1");
    if (!h1 || document.getElementById("nl-yo-purchased")) return;
    var el = document.createElement("div");
    el.id = "nl-yo-purchased";
    el.className = "stock-warning";
    el.innerHTML =
      "<strong>Your Month One download is on the way.</strong> Optional: lock in Months 2–12 below before life gets louder — Month Two is when crying peaks for most babies.";
    h1.insertAdjacentElement("afterend", el);
  }

  function bindCtas() {
    document.querySelectorAll(".nl-yo-cta").forEach(function (btn) {
      btn.addEventListener("click", checkout);
    });
  }

  function initStickyBar() {
    var bar = $("#nl-yo-sticky-bar");
    if (!bar) return;
    bar.classList.add("is-visible");
    if (window.matchMedia && window.matchMedia("(max-width: 900px)").matches) {
      document.documentElement.classList.add("nl-pdp-sticky-on");
    }
    document.querySelectorAll(".nl-yo-sticky-btn").forEach(function (btn) {
      if (btn.classList.contains("nl-yo-cta")) return;
      btn.addEventListener("click", function () {
        var block = $("#nl-yo-checkout");
        if (block) block.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function boot() {
    postPurchaseNote();
    bindPlans();
    bindCtas();
    initStickyBar();
    initKachingSubscription();
    tickTimer();
    tickViewers();
    socialToast();
    track("ViewContent", {
      content_name: "Nightlight Product PDP",
      content_category: "year_offer_default",
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
